import angular from 'angular';

import '../../../main/factory/acquirer';
import '../../../main/factory/authentication';
import '../../../core/main/directive/alphanumeric/directive'
import '../../../core/main/directive/numbers_only/directive'
import './style.scss';

document.write(require('./view.html').default);

angular.module("merchant.application.module.acquirers.acquirer", [
]).controller("merchant.application.module.acquirers.acquirer.controller", [
    "$scope", "$controller", "$window",
    "merchant.application.main.factory.acquirer",
    "merchant.application.main.factory.authentication",
    function($scope, $controller, $window, Acquirer, Authentication) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.acquirer) {
            $scope.model.acquirer = {};
        }
        $scope.model.acquirer.saved = false;
        $scope.model.acquirer.ref = null;
        $scope.model.acquirer.data = {};
        $scope.model.acquirer.original = {};
        $scope.model.acquirer.data.status = "INACTIVE";
        $scope.model.acquirer.isNew = false;
        $scope.model.acquirer.data.terminalIds = [];
        $scope.model.currentError = null;

        $scope.populateAcquirer = function() {
            var ref = $scope.model.acquirer.ref;
            if (ref) {
                Acquirer.read({
                    ref: ref,
                    coreMerchantId: Authentication.merchantId()
                }, function(response) {
                    $scope.model.currentError = null;
                    $scope.model.acquirer.data = response;
                    $scope.model.acquirer.original = angular.copy(response);
                }, onError);
            }
        };

        $scope.submit = function() {
            $scope.model.acquirer.saved = false;
            $scope.model.currentError = null;
            if ($scope.form.$valid && !$scope.isTidListInvalid()) {
                if ($scope.model.acquirer.isNew) {
                    $scope.newAcquirer();
                } else {
                    $scope.updateAcquirer();
                }
            }
        };

        $scope.updateAcquirer = function() {
            if ($window.confirm("Are you sure?")) {
                var parameters;
                $scope.model.acquirer.saved = false;
                parameters = angular.copy($scope.model.acquirer.data);
                parameters.ref = $scope.model.acquirer.ref;
                parameters.coreMerchantId = Authentication.merchantId();
                Acquirer.update(parameters, function() {
                    $scope.model.acquirer.saved = true;
                }, onError);
            }
        };

        $scope.newAcquirer = function() {
            var parameters = angular.copy($scope.model.acquirer.data);

            parameters.status = 'INACTIVE';
            parameters.coreMerchantId = Authentication.merchantId();

            Acquirer.create(parameters, function() {
                $scope.model.acquirer.saved = true;
            }, onError);
        };

        const activeStatus = ['ACTIVE', 'REFUND_ONLY', 'BLOCKED']
        $scope.isStatusActive = function() {
            return activeStatus.some(s => s === $scope.model.acquirer.data.status);
        };

        $scope.resetDataOnChange = function() {
            const isOriginalStatusActive = activeStatus.some(s => s === $scope.model.acquirer.original.status);
            var isNewStatusActive = $scope.isStatusActive();
            if (isOriginalStatusActive && isNewStatusActive) {
                $scope.model.acquirer.data = angular.copy($scope.model.acquirer.original);
            }
        };

        $scope.addTerminalId = function() {
            $scope.model.acquirer.data.terminalIds.push({
                value: ""
            });
        };

        $scope.deleteTid = function(index) {
            $scope.model.acquirer.data.terminalIds.splice(index, 1);
        };

        $scope.isTidListInvalid = function () {
            for(var i = 0; i < $scope.model.acquirer.data.terminalIds.length; i++) {
                var tidValue = $scope.model.acquirer.data.terminalIds[i].value;
                if (tidValue === '') return true; //empty is invalid
                if (tidValue.length > 8) return true; //too long is invalid

                //look for duplicates
                for(var j = i + 1; j < $scope.model.acquirer.data.terminalIds.length; j++) {
                    if (tidValue === $scope.model.acquirer.data.terminalIds[j].value) {
                        return true;
                    }
                }
            }
            return false;
        };

        $scope.duplicateTid = function (tid) {
            if (tid.value === '' || tid.value === undefined) return false; //IGNORE empty for validation purposes
            var count = 0;
            for(var i = 0; i < $scope.model.acquirer.data.terminalIds.length; i++) {
                if (tid.value === $scope.model.acquirer.data.terminalIds[i].value) {
                    count++;
                }
            }
            //if there is more than 1 with this exact value, then it's invalid
            return count !== 1;
        };

        $scope.$watch("model.ref", function(ref) {
            if (ref === null || ref === "") {
                $scope.model.acquirer.isNew = true;
                $scope.model.acquirer.ref = null;
            } else {
                $scope.model.acquirer.isNew = false;
                $scope.model.acquirer.ref = ref;
                $scope.populateAcquirer();
            }
        });

        function onError(error) {
            var currentError = {
                message: "Unknown error"
            };

            if (error.status === 500) {
                currentError.message = "Internal Server Error"
            } else if (error.status === 404) {
                currentError = {
                    errorCode: "not_found",
                    message: "Acquirer not found"
                };
            } else if (error.data && error.data.errorCode) {    // look for api errors with this structure
                currentError = error.data;
            }
            $scope.model.currentError = currentError;
        }
    }
]);
